export const tr = {
    'column-title-city': 'Şehir',
    'column-title-feedbacks': 'Yorumlar',
    'column-title-freelancers': 'Uzmanlar',
    'column-title-score': 'Değerlendirmeler',
    'column-title-services': 'Fiyat ve süre',
    noScore: 'Yorum sayısı çok az'
};
